function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #a09958;\n      }\n\n      .st1 {\n        fill: #afa96e;\n      }\n\n      .st2 {\n        fill: #00263e;\n      }\n\n      .st3 {\n        fill: #99d6ea;\n      }\n\n      .st4 {\n        fill: #00a9e0;\n      }\n\n      .st5 {\n        fill: #ffb81c;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "color_palettes"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "37.8 94.7 75.8 7.1 51.8 12.9 37.8 94.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st5",
  points: "20.4 20.5 30.1 14.7 0 7.1 37.8 94.7 20.4 20.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "30.8 18 51.8 12.9 54.2 0 30.1 14.7 30.8 18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "37.8 94.7 51.8 12.9 30.8 18 37.8 94.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "30.1 14.7 20.4 20.5 30.8 18 30.1 14.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "20.4 20.5 37.8 94.7 37.8 94.7 30.8 18 20.4 20.5"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "97.6 30.9 80 79.2 62.5 30.9 57.3 30.9 76.5 83.5 83.2 83.5 102.5 30.9 97.6 30.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M133.6,63.1c0-4.8-.6-8.9-1.8-12-1.2-3.1-3-5.5-5.3-6.9-2.3-1.5-5.1-2.2-8.2-2.2s-6.1.8-8.4,2.2c-2.4,1.5-4.3,3.8-5.6,6.9-1.3,3.1-2,7.1-2,11.9s.7,9.1,2.1,12.2c1.4,3.1,3.5,5.4,6.3,6.8,2.8,1.4,6.2,2.2,10.2,2.2s3.4-.1,5.2-.4,3.5-.7,5.4-1.3h.1v-4.3h-.2c-1.9.6-3.7,1.1-5.3,1.4-1.6.3-3.2.4-4.7.4-3.1,0-5.7-.5-7.8-1.6-2.1-1.1-3.7-2.8-4.7-5.2-.9-2.2-1.5-5-1.6-8.5h26.3v-1.7h0ZM112.4,47.4c1.6-1,3.6-1.6,5.8-1.6s4.2.5,5.7,1.6c1.6,1,2.8,2.8,3.6,5.1.8,2.2,1.2,5,1.3,8.6h-21.6c0-3.5.5-6.4,1.3-8.6.9-2.4,2.2-4.1,3.8-5.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M171.4,47.8c-1.1-2.1-2.7-3.6-4.6-4.5-1.9-.9-4.2-1.4-6.7-1.4s-4.9.5-7.1,1.4c-2.2.9-4.2,2.2-5.9,3.9h0l-.3-4.7h-4.1v41h4.8v-31.3c1.1-1.4,2.3-2.6,3.7-3.4,1.4-.9,2.8-1.5,4.2-1.8,1.4-.4,2.8-.6,4.1-.6,2.8,0,5,.7,6.6,2.2,1.6,1.4,2.4,4,2.4,7.7v27.3h4.8v-27.4c0-3.4-.6-6.2-1.6-8.3h0Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "187.7 79.4 210.5 45.5 210.5 42.6 181.9 42.6 181.9 46.8 204.3 46.8 181.5 80.6 181.5 83.5 211 83.5 211 79.4 187.7 79.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "237.2 42.6 231.1 42.6 215.4 83.5 220.5 83.5 234.3 47.2 246.2 78.7 235.1 78.8 233.9 83.6 253 83.5 237.2 42.6"
}));

function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253 94.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/newLogo.fc6b0a17.svg";
export { ForwardRef as ReactComponent };